import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/components/Button';
import Title from '@/components/Title';
import ReviewCardGrid from '@/components/WukongReviews/ReviewCardGrid';
import useIsMobileNew from '@/hooks/useIsMobileNew';

/**
 * ELA 学员故事模块 - English
 * 展示 Trustpilot 好评（数据来自 wallOfLove）
 */
const ELA: React.FC = () => {
  const isSmallScreen = useIsMobileNew();
  const { t, i18n } = useTranslation(['english']);

  return (
    <div className="mx-auto mt-[80px] lg:mt-[140px] xl:mt-[200px]">
      {/* 标题 */}
      <div className="container">
        <Title
          className={isSmallScreen ? '[&_strong]:inline' : ''}
          innerHTML
          theme="english">
          {t('ela-标题', { tag: isSmallScreen ? '' : '<br/>' })}
        </Title>
      </div>

      {/* 评分条 + 好评卡片 */}
      <ReviewCardGrid subject="english" />

      {/* Explore more 按钮 */}
      <div className="text-center">
        <Button
          size="xl"
          className="mt-6 lg:mt-12 xl:mt-[60px] [&]:text-base [&]:font-medium [&]:xl:text-xl"
          onClick={() => {
            const path =
              i18n.language === 'zh'
                ? '/zh/wukong-reviews/#reviews'
                : '/wukong-reviews/#reviews';
            window.location.href = path;
          }}>
          {t('口碑-按钮')}
        </Button>
      </div>
    </div>
  );
};

export default ELA;
